"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassPredictionMapper = void 0;
const jsonapi_utils_1 = require("../../../#core/jsonapi-utils");
class ClassPredictionMapper {
    toClassPrediction(classPredictionResource) {
        return {
            id: classPredictionResource.id,
            createdAt: new Date(classPredictionResource.attributes.createdAt),
            updatedAt: new Date(classPredictionResource.attributes.updatedAt),
            jobId: jsonapi_utils_1.pluckRelationshipId(classPredictionResource.relationships.job),
            productId: jsonapi_utils_1.pluckRelationshipId(classPredictionResource.relationships.product),
            options: classPredictionResource.attributes.confidences.map((confidence, index) => ({
                confidence,
                classId: classPredictionResource.relationships.classes.data[index].id,
            })),
        };
    }
    toClassPredictionResource(classPrediction) {
        const classIds = [];
        const confidences = [];
        for (const option of classPrediction.options) {
            classIds.push(option.classId);
            confidences.push(option.confidence);
        }
        return {
            id: classPrediction.id,
            type: 'ClassPrediction',
            attributes: {
                createdAt: classPrediction.createdAt.toISOString(),
                updatedAt: classPrediction.updatedAt.toISOString(),
                confidences,
            },
            relationships: {
                classes: jsonapi_utils_1.createRelationships(classIds, (id) => ({ type: 'Class', id })),
                product: jsonapi_utils_1.createRelationship(classPrediction.productId, (id) => ({ type: 'Product', id })),
                job: jsonapi_utils_1.createRelationship(classPrediction.jobId, (id) => ({ type: 'Job', id })),
            },
        };
    }
}
exports.ClassPredictionMapper = ClassPredictionMapper;
//# sourceMappingURL=#class-prediction-mapper.js.map